import React from 'react';
import classNames from 'classnames';
import { image } from '../../../../utils/data/baseUrl';
import { icons } from '../../../../constants/rewards';

const QuizWinModalReward = React.forwardRef(function QuizWinModalReward({ type, value, mod }, ref) {
  return (
    <div
      className={classNames('quiz-win-modal__reward', {
        [`quiz-win-modal__reward_${type}`]: type,
        [`quiz-win-modal__reward_${mod}`]: mod,
      })}
    >
      <div className='quiz-win-modal__reward-icon'>
        <img src={image(icons[type])} alt={type} />
      </div>
      {!!value && (
        <div className={'quiz-win-modal__reward-value'}>
          {['coin', 'xp', 'charm', 'energy'].includes(type) && '+'}
          {value}
        </div>
      )}
    </div>
  );
});

export default QuizWinModalReward;
